import * as z from "zod";
import { monitoringAnalytics } from "./monitoringAnalytics";
import { mutator } from "./mutator";

const setWorkflowTimeSavedSchema = z.object({
  analytics: monitoringAnalytics.optional(),
  workflowId: z.string(),
  estimatedMinutesSaved: z.number().int().min(0).nullable().optional(),
  estimatedBuildMinutesSaved: z.number().int().min(0).nullable().optional(),
});

export const setWorkflowTimeSaved = mutator({
  stripKeys: { analytics: Object.keys(monitoringAnalytics.shape) },
  schema: setWorkflowTimeSavedSchema,
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({
    tx,
    args: { workflow, estimatedMinutesSaved, estimatedBuildMinutesSaved },
  }) => {
    const now = Date.now();
    const patch: {
      id: string;
      updatedAt: number;
      estimatedMinutesSaved?: number | null;
      timeSavedSource?: "manual" | null;
      estimatedBuildMinutesSaved?: number | null;
      timeSavedBuildSource?: "manual" | null;
      timeSavedUpdatedAt?: number | null;
    } = {
      id: workflow.id,
      updatedAt: now,
    };

    if (estimatedMinutesSaved !== undefined) {
      patch.estimatedMinutesSaved = estimatedMinutesSaved;
      patch.timeSavedSource = estimatedMinutesSaved == null ? null : "manual";
    }
    if (estimatedBuildMinutesSaved !== undefined) {
      patch.estimatedBuildMinutesSaved = estimatedBuildMinutesSaved;
      patch.timeSavedBuildSource =
        estimatedBuildMinutesSaved == null ? null : "manual";
    }
    if (
      estimatedMinutesSaved !== undefined ||
      estimatedBuildMinutesSaved !== undefined
    ) {
      patch.timeSavedUpdatedAt = now;
    }

    await tx.mutate.workflows.update(patch);
  },
});
